import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getItemWebStorage } from '../../../../features/webStorageSaver'
import { useAppSelector } from '../../../../stateManagement/hooks/redux'
import { MapTooltip } from '../../../../widgets/map/mapAddons/mapTooltip'
import MapWidget from '../../../../widgets/map/mapWidget/MapWidget'
import { LastYearsMapFilter } from '../../../lastYearsMapFilter'
import { getBasicObjectTypeLayer, getAllObjectsLayer } from '../../../../widgets/map/mapFeatures/layers'
import { getObjectsOnWMSLayer } from '../../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint'
import { showMapTooltip } from '../../../../widgets/map/mapFeatures/mapFunctions/showMapTooltip/showMapTooltip'
import { setMapTooltipIsVisible } from '../../../../stateManagement/reducers/MapTooltipSlice'
import { mapLayersDict } from '../../mapLayersDict'
import { setHighContrastModeIsEnabled } from '../../../../stateManagement/reducers/ContentHeaderSlice'
import ContentHeader from '../../../../widgets/contentHeader/ContentHeader'
import { buildYearsEnv, getLastYearsCqlFilter } from '../../../lastYearsMapFilter'

const roadDiagnosticsSegmentsDefaultFilters = {
    mapFilter: "EventTypeId=1"
}

export function MapRoadDiagnosticsSegments() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const mapName = "RoadDiagnosticsSegments"
    const numberOfYears = 5
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const [isSmallWindow, setIsSmallWindow] = useState(true);
    const sideBarState = useAppSelector(state => state.sidebar.sidebarIsShown)
    const yearFilter = useAppSelector(state => state.mapFilters?.lastYearsMapFilters)?.[mapName] ?? {}
    const { wmsServer, wmsVersion, workspace } = getItemWebStorage('currentConfig')

    const roadsLayer = getAllObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    useEffect(() => {
        const { mapLayer, caption } = mapLayersDict[mapName] ?? {}
        caption && setMapTitle(`Карта «${caption}»`)
        if (!mapLayer) {
            navigate('/app/error')
        }
        let layerFilter = getLastYearsCqlFilter(yearFilter)
        const roadDiagnosticsSegmentsMapDefaultFilter = roadDiagnosticsSegmentsDefaultFilters?.mapFilter
        if (roadDiagnosticsSegmentsMapDefaultFilter) {
            layerFilter += ` and ${roadDiagnosticsSegmentsMapDefaultFilter}`
        }
        const objectTypeLayer = getBasicObjectTypeLayer(
            mapLayer,
            wmsServer,
            wmsVersion,
            workspace,
            layerFilter,
            undefined,
            buildYearsEnv(numberOfYears)
        )
        setAdditionalLayers([objectTypeLayer])
        dispatch(setHighContrastModeIsEnabled(true))
    }, [yearFilter]);

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setIsSmallWindow(contentHeaderWidth < 440);
    }, [sideBarState, navigate])

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        const hasSeenYearForMobile = getItemWebStorage("lastYearsMapFilters")?.[mapName]
        if (!hasSeenYearForMobile && contentHeaderWidth < 440) {
            navigate('/app/map/RoadDiagnosticsSegments/filters')
        }
    }, [])

    function applyMapTooltip(map: any) {
        const pointerMoveFunc = (event: any) => showMapTooltip(event, mapName, additionalLayers[0], map)
        map?.on("pointermove", pointerMoveFunc)
        return {
            off: () => {
                map?.un("pointermove", pointerMoveFunc)
                dispatch(setMapTooltipIsVisible(false))
            }
        }
    }

    function applyMapObjectsFind(map: any) {
        const clickFunc = (event: any) => getObjectsOnWMSLayer(event, mapName, additionalLayers[0])
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "mapTooltip",
            func: applyMapTooltip
        },
        {
            name: "objectsFind",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={mapName} type="map" option="roadDiagnosticsSegments" />
            {!isSmallWindow && <LastYearsMapFilter filterType="header" numberOfYears={numberOfYears} objectType={mapName} />}
            <div className={`map-widget-with-toast${!isSmallWindow ? ' road-diagnostics-segments' : ''}`}>
                <MapTooltip type={mapName} />
                <MapWidget additionalLayers={additionalLayers} permanentLayers={permanentLayers} mapEventHandlers={mapEventHandlers} />
            </div>
        </>
    )
}
